import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1c2d2ee2/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The import action transfers data or objects from an external source into a system.`}</p>
    </PageDescription>
    <h4>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "experimental/about"
      }}>{`Experimental`}</a></p>
    <h4>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "68.4451219512195%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAACAElEQVQ4y52UW28SQRTH+wlFH3gAlpbWUhXLg8gtEO63BQqEhPAN/AL1zZDUcHlAXmqa0CataHng0mJQoJDI5e+eUxe6LRrTSX7Z2Zn//OecM7O7AaktFgusazS+DvxDv7EyW2A2n7N2vfze4nssDakzHAywv/8KL02vYdjegVbQQ7+1hV3j3gOMey9g2HkOnV4PQb+JTcM2njx9hsPD92zKhq1WCyqVCk6nExbLG9hsNsZqtfLTbifsijEZh8MBk8mEQqGwMmy32xAEAbFYDOFwBNFoFFGpX6vV0Gw20Wh8kWgwnU4Hx8efEYlEmHg8Do/Hg0qlojTUaDQ8GQ6HEQqFWFyvn6J7dY2r6x76/T4zm/7C5bevrCEoCLfbjVKppExZp9Mhm80ikUgwqVQK5xcN9H/eoP9jhMHwBqPhQHof46R+gYNkcqkLBALKCGXDdDrNO4qiyOKzs1N87/WY4WgEzCb4dD7Duw+XSB+IklZEUjL2+Xwol8tKQznlYDC4TNtieQuz2Qyj0Yh8Ps9RHB195BOVNVRvl8ulTJlqqNVqOSoSkZignb1eL+P3+2/rJm14VyMbPohQrVZzurSQakIE/ywmqC+P34Xm6OoUi8WVYbfb5buUy+W4jplM5r+hg6Qoq9XqynAufXLj8RiTyeRR0NrpdHpr+Lcfw2Maef0G+dZ/PB2beuUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Example of an import modal",
        "title": "Example of an import modal",
        "src": "/static/f2fd074cdf8a093d72cd3d0782091f51/3cbba/0.png",
        "srcSet": ["/static/f2fd074cdf8a093d72cd3d0782091f51/7fc1e/0.png 288w", "/static/f2fd074cdf8a093d72cd3d0782091f51/a5df1/0.png 576w", "/static/f2fd074cdf8a093d72cd3d0782091f51/3cbba/0.png 1152w", "/static/f2fd074cdf8a093d72cd3d0782091f51/0b124/0.png 1728w", "/static/f2fd074cdf8a093d72cd3d0782091f51/4ea69/0.png 2304w", "/static/f2fd074cdf8a093d72cd3d0782091f51/0cbe4/0.png 2624w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an import modal</Caption>
    <h2>{`Choose a file (modal)`}</h2>
    <p>{`Where a single file is imported, import can take place in a modal.`}</p>
    <p>{`When importing, users should have the option of uploading a local file using the file upload component, offering file drag and drop and the ability to browse locally to select a file. Additionally, provide the ability to add a file from an external resource.`}</p>
    <p>{`If additional actions (e.g. adding metadata) are required to be performed on the file(s), consider whether it would be more appropriate to use a side panel or full page instead of a modal.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABpUlEQVQoz42STW/aQBCG+atc+KgQEgiJX9Fbjzlw5NRDTz1VglsvbWMjkJIWC/wd4zi7XnttY3izuy6p0xCSkR7teLXzaMa7DfyN4/GIen6J/6O+16gfStMUYRgiz/MniqJ4kXPOFfK8pN7EMyEhBGvDgOM4cF0Xtu3ANE1YliVyW61yP45jBaUUjLHXhVEUwTDWotAUoq2SeZ4L3/eUSOL7vpJIpPTNDo2Nha3pYLO14XoBCE3wIGAsQZIkSiQ7OyH3XhVynmH3wBESjnuSCVLchTH8kAlx/DSqhFCGiMj8wsiMxQiCO4S7QK334U4UUMWpI0Krb5RUzoRDwVCVnxHKAvnjPc9TFxMEOzWSpLrZDEWeIaIcH79wfLjK8E3jSnY4VF02zr2lc1GWJXLxbMp9AZYW+Px9j09fS/wy9pXwiH8dHqRexHQ6Rb/fx2g0wnA4VAwGA4zHY8zncyyXS2iahsVCh/lHh72+hrW5fTnySTiZTNBsNtHtdtFut9HpdNBqtdDr9TCbzbBaraDrumCBa22BHz813Nz+fn4p7x35UtRrHwGlg4jmlXUh3wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an import modal",
            "title": "Example of an import modal",
            "src": "/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/3cbba/01.png",
            "srcSet": ["/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/7fc1e/01.png 288w", "/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/a5df1/01.png 576w", "/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/3cbba/01.png 1152w", "/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/0b124/01.png 1728w", "/static/3b4b5e16c5b0c1c068968f71d2d8f6ce/e957c/01.png 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an import modal</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB0ElEQVQoz42SS4saQRRG56+68QEiKIL/Irtsko0QCK6yCAQCgRBdBJJFkmlFg844GftRtnbbbVc/fJ+UbR5ORppc+KhLcevUd2/VFb/icDhwnmfp3zjfuzoviuMY13VZr9d/tNlsHuVJkqQ61h91buIB0PeXjMd3WJaFEALTtJjoOoZhqNxE1410X0qZKggCwjDKAHoe9z/GmIaC6BO1TpjZQmnKVBwvsbBtO4VFYahgUjnNcDhzA3pDk+/jKYMbwe3EQTgJlhMz92ICqVqNE0IZ4nghtitx/QzgItgg3BUz7yR7kWDOQgwlqSAjM+Cd5vFhsFQXSfylZOpmAf0I3ZpjTR0MMUfYC+VEMl9IPF/ycSh5/kbn5YvPOMsQdgFRFHM6fgF4HPJEDd4StnoENbu5gwxjNauYSLW6265V1YpdJHnyekXx2Yr3WpLC9vuTy6tLf+lS7Pc7Vmv1bdTXWcZbXn3a8vTtjm932xPwwF+H+yNeRavVolKpUK/XqdVqqarVKo1Gg06nQ7/fR9M0er0u+m0Xc3yNcT963PJvYLPZJJfLUSqVKBQKFItF8vk85XKZdrvNYDCg2+0q9bjWenz5qjEc3Tx8lP9tOSvOz/4EnoaFNV4iIcsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of drag and drop file import",
            "title": "Example of drag and drop file import",
            "src": "/static/763ac94e9b0b152ed1a67e75fb5cab60/3cbba/02.png",
            "srcSet": ["/static/763ac94e9b0b152ed1a67e75fb5cab60/7fc1e/02.png 288w", "/static/763ac94e9b0b152ed1a67e75fb5cab60/a5df1/02.png 576w", "/static/763ac94e9b0b152ed1a67e75fb5cab60/3cbba/02.png 1152w", "/static/763ac94e9b0b152ed1a67e75fb5cab60/0b124/02.png 1728w", "/static/763ac94e9b0b152ed1a67e75fb5cab60/e957c/02.png 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of drag and drop file import</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.58333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABfUlEQVQ4y5WSu27CMBiFebKOpVPVpe1WiQGRpRECMTB2KGqHXt4gW3kjpjAgAkEg7uTioOTUx2AawqWtpU/nj2OfnD92DtuRJAnS9TmyIz2XSy/yfR/j8RhCiB1RFB3UQRAouJ6kQ+wZzmYztNtt9Ho99Pt9pd1uF47jqJrqui6Wy6VisVjA87zzhjQYDAZqI02p+pkMh0OsVisFTc8m5MvpdKq+PJ/Pdwm4mar5c0L+F22k4bOe00Y63a+GTMi2tUnWPI0+GKL3HxiGYahMqVxI5clm4TvbttFqtTAajU4npAHb0abaOA3n2Gan01E3YjKZnDbkQn6RsNb3jHi+NAqEVKE0WscQEl/Wey0fu+3HR8RjYx9bJTwQH5utiUIljONYbWk2mzBNE7VaDZVKRVKVlFGu1vHw5uDuM8bteygRuP8QuH4VqH+tD1vWhpZloVAowDAMlEolCbWIomHi5tlF/gW4bMTIN4ArWV88AY/WJhlT/rPln7aypFv+BnuTILecNz21AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of loaded files in the import modal",
            "title": "Example of loaded files in the import modal",
            "src": "/static/2b2291b208a10dbe0f7b534aeeef7a66/3cbba/03.png",
            "srcSet": ["/static/2b2291b208a10dbe0f7b534aeeef7a66/7fc1e/03.png 288w", "/static/2b2291b208a10dbe0f7b534aeeef7a66/a5df1/03.png 576w", "/static/2b2291b208a10dbe0f7b534aeeef7a66/3cbba/03.png 1152w", "/static/2b2291b208a10dbe0f7b534aeeef7a66/0b124/03.png 1728w", "/static/2b2291b208a10dbe0f7b534aeeef7a66/e957c/03.png 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a loaded file in the import modal</Caption>
      </Column>
    </Row>
    <h3>{`Import from a URL (modal)`}</h3>
    <p>{`If your product supports importing from a URL, use this method.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABeklEQVQoz41STU/CQBD1r3KhISEh4SP8Co8mJl44cvPowRPcRW2VGgURobTENv2kLdD22RkpKUgaJnmZ2d2Zt2929gI7S5IE+bgIx5bfu8gn+b4PwzCwXq/32Gw2/+IgCBiUT8iLOCC0LAvj8RiKomCxWLCfzWaYz+cck1dVFa7rMhzHwWq1KiYkAk3TuJBIyWdrwnK5hOd5DCItVEiHpmnyzbZt7xVQMfkMZysMw3CfnCkg4ow8OyNYtgvTSmOvgJBIdF3nwZAntXk1LilPEfouZTOS7Qoxl58gJCXT6ZTfkTwNgi6hp+CpBiEQhRA/XdRudAhXP7gfOFwbxzvCU3/plEVRlH6ZTZq4xUQLcX3n4PLWwMMo+CPMtxzHMW92u13UajW0Wi00Gg00m03U63W02230+30Mh0M8iyLeZAnq1yuUiQjle4TkuOWMsNPpoFQqoVKpQBAERrlcRrVaRa/XgyzLkCSJ8SS+YPAo4v1jdDiUc1susnztL+nXiPE6dRX0AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of importing with a URL",
            "title": "Example of importing with a URL",
            "src": "/static/46bbb9a0ab71b282415cfa6e73c3dcb9/3cbba/04.png",
            "srcSet": ["/static/46bbb9a0ab71b282415cfa6e73c3dcb9/7fc1e/04.png 288w", "/static/46bbb9a0ab71b282415cfa6e73c3dcb9/a5df1/04.png 576w", "/static/46bbb9a0ab71b282415cfa6e73c3dcb9/3cbba/04.png 1152w", "/static/46bbb9a0ab71b282415cfa6e73c3dcb9/0b124/04.png 1728w", "/static/46bbb9a0ab71b282415cfa6e73c3dcb9/e957c/04.png 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of importing with a URL</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABZUlEQVQ4y32Uy27CMBBF+cFW0GWFumYBSZSf6AO1XbQfgfghyqJIiOcGQYA8i3PLNYybpBhLVxdbnuOZsUMN55HnOYqDc5suDVmvFTdFUYTVaoU0TZFlWUmyRo/j2CgMQxNPLwGDIMBoNMJsNsNisdA+nU615vO58e12i91uZ3QVOJlMNIyBBNJlTi2XSw3Z7/far2bIktfrtc6AcDoDqipmR7AVmCSJAYk4l7UihC5rViCbvNlsShnaxGq4n66UsmfI01mWOG/1ktjr4XCo+1t8ZiUgNwqMJ0sWPKiq8XiMwWCgL8oKJIC3yLIFZN5ckpb0c1A4qFz//ldy8aXbvgQgY5fZmLPik1T0FyNAOaHf76PdbsPzPDiOY9TpOHh4+sLdG1B/SVDvpmgcdfOcovmRIYgqtyzAXq+HVqsF3/c11D3K81y4rof7x2803oHGqzoKGn7bBZqfKANtfw6XR27VKTzHLxrkIMERL+hNAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a file imported by URL",
            "title": "Example of a file imported by URL",
            "src": "/static/d4b3b69de0b46d16c9537ff8d7e1dedb/3cbba/05.png",
            "srcSet": ["/static/d4b3b69de0b46d16c9537ff8d7e1dedb/7fc1e/05.png 288w", "/static/d4b3b69de0b46d16c9537ff8d7e1dedb/a5df1/05.png 576w", "/static/d4b3b69de0b46d16c9537ff8d7e1dedb/3cbba/05.png 1152w", "/static/d4b3b69de0b46d16c9537ff8d7e1dedb/0b124/05.png 1728w", "/static/d4b3b69de0b46d16c9537ff8d7e1dedb/e957c/05.png 1920w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a file imported by URL</Caption>
      </Column>
    </Row>
    <h2>{`Choose a file (full page or side-panel)`}</h2>
    <p>{`Use the drag and drop file upload component and offer the option to browse locally to select a file. Note that file selection should be restricted to allowed file types.`}</p>
    <p>{`If additional actions (e.g. adding metadata) are required to be performed on the file(s) they should be done separately to the file upload, prior to the import action being completed. This could be in a subsequent step or if there is sufficient space include those actions in a single step.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.4451219512195%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABWElEQVQ4y62UTW+CQBCG/f8XDyZAe2jT9Oav6B/waKLWHupHgMICu8sCXcC3O9tQMWq0RpI3M7Azz3xkw2C32+FeD7EG5DRNg+XyHfP5HLPZ7CpRbKfpdArGmIVaYFEUeHp+gffwCMdx4XoeXNeFZ+w5OY6D0Whk/eFwiMlksgdSh5VuUGqgboG2bXFpFavVCuPxGIvFApxzaK0PR95s1iboE2EQIAh8hOEX4ji2SpIUWZYhTVMr8um77/uIosiOq5Tqd1gjihOstyGCkIElmU3KTGUhOErFIaUwvjRWGiusJUie5/ad1vYHrOvaVmamE84pOP9NyCVYKvGxkaaAOICR7esIaDsyoop0qFQB/V1guVV4fSsQxlRg32VfJ4H9w07cKDej6lL0RhbXATvIcbA0a+hGFUejXuzwFp0E0l26VbT7AyBdyKqqUJaltf8V5VFTFnjvn8MPjvUlzpji7awAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an import dialog in a full page view",
            "title": "Example of an import dialog in a full page view",
            "src": "/static/a1b5e443d68713373ad111091cf72f3c/3cbba/06.png",
            "srcSet": ["/static/a1b5e443d68713373ad111091cf72f3c/7fc1e/06.png 288w", "/static/a1b5e443d68713373ad111091cf72f3c/a5df1/06.png 576w", "/static/a1b5e443d68713373ad111091cf72f3c/3cbba/06.png 1152w", "/static/a1b5e443d68713373ad111091cf72f3c/0b124/06.png 1728w", "/static/a1b5e443d68713373ad111091cf72f3c/4ea69/06.png 2304w", "/static/a1b5e443d68713373ad111091cf72f3c/0cbe4/06.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an import dialog in a full page view</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.4451219512195%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABpklEQVQ4y62Uy07CQBiFeURYAi8CpFzLpVwlLIQngIS4Z2NCXOBGwZhCQlgaC6IBLBelpeXYfwCbRioaneR0Jp3M1/9ypg4YY7vd/lrHBr132G3+ZOi6bkD0/bzjOOgxn88RiUSQyWTYHAwGT4hDLpfDebmMcqWCQuEM7XbbBEqSBKfTiVAoBJ/PB47jbEVAv9+PZvMKzxMZ0ugFj9IQi8XCBI5GI3i9XiQSCcRiMSaKlOd5to5Go5Y17XU6d1iu3vG2JJAGbZ82Aw6HQ3g8HpZGMplEKpViEgThyFowPszj+kbEWgWavSXKl69YKxtqiwmkCIvFItLpNKvlMWWzWSbBAN927qEqCroPc6QvJnieqlYgRZjP5y0RHhNFSumLoriziqbgSTYau9KsQLfbzaKjOtEBO8XjcYTDYXS7PQak2hFI1zdmDQ9NoXToADXHTpQBNaXf71s8qWmaCSTbuFwuFgFZg+zznQKBAFqtFmazGWRZhqqqUIx6fgKn0ykrer1eR7VaPalarYZSqcQ82Wg0MBgMMB6Pdz78y9U73N8vV+8/fw4fM9qXWLv0syoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of drag and drop file import in a full page view",
            "title": "Example of drag and drop file import in a full page view",
            "src": "/static/2e210dae65741bf1cdb74772b2e5392f/3cbba/07.png",
            "srcSet": ["/static/2e210dae65741bf1cdb74772b2e5392f/7fc1e/07.png 288w", "/static/2e210dae65741bf1cdb74772b2e5392f/a5df1/07.png 576w", "/static/2e210dae65741bf1cdb74772b2e5392f/3cbba/07.png 1152w", "/static/2e210dae65741bf1cdb74772b2e5392f/0b124/07.png 1728w", "/static/2e210dae65741bf1cdb74772b2e5392f/4ea69/07.png 2304w", "/static/2e210dae65741bf1cdb74772b2e5392f/0cbe4/07.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of drag and drop file import in a Slide over panel</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.4451219512195%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABNUlEQVQ4y62UzW6CUBCFff+NCxOgXbTplndhaYLWDRRjDH+CCggXTj2T3igoaWsk+TLDZObcmbmESdd1eNZDrQkdpRRWq08sFgu4rvsnmKuZz+eI41hERbAoCry9f8B6eYVhmDAtC6ZpwjrbMQzDwGw2E386ncJxnIsgO6xOCmUNNApo2xa/rcL3fdi2jeVyiSzLUNd1f+T1OkAQfGG73WKz2YiNokhIkgS73Q5pmgr0GWdeGIYy7vF4vHTYNM05KZNCoot4Mtnv98jzXNA+LUUOh4O8c209wesCJmkY4yFDMZ2vuRFkMYPXlGUp3Xqe1+uU9pobQe5Qj0gRTVH82LIaFRsVZJA74Q0POdVqdNy7ghx5uLsh9zob7ZCC+kYfgevqCfKDrKpK9kX7X1jHpkTw2T+Hb3XNJ9wp3pPyAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of files loading into the import dialog",
            "title": "Example of files loading into the import dialog",
            "src": "/static/cfd8deee736e7c259d3f4e65a333937c/3cbba/08.png",
            "srcSet": ["/static/cfd8deee736e7c259d3f4e65a333937c/7fc1e/08.png 288w", "/static/cfd8deee736e7c259d3f4e65a333937c/a5df1/08.png 576w", "/static/cfd8deee736e7c259d3f4e65a333937c/3cbba/08.png 1152w", "/static/cfd8deee736e7c259d3f4e65a333937c/0b124/08.png 1728w", "/static/cfd8deee736e7c259d3f4e65a333937c/4ea69/08.png 2304w", "/static/cfd8deee736e7c259d3f4e65a333937c/0cbe4/08.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of files loading into the import dialog</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.4451219512195%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABTklEQVQ4y62UTU+DQBCG+/+NiUkVqAcbjz0Yf4IXj/ZoU2ovWCpiSgvL8qHQvvJusoWSEj9Skiez2ew8zMwServdDqd66OpxUZYl5vMX2LaN6XT6K3iWzGY2JpNnBEGgpEqYpiluhrewBtcwDBOmZcE0TVhV7MIwDFz2+7gyBjg7v8DTeFwLWWH+WSL7AooS2G63+GkUzusC93cjjB4+MHwE4rRk07VwuXThugv4vg/P81RcrVaK9XqNMAyx2WwUXHPf897g+QHc9xBSJnWFRVFUhyKVSHRSFEWKOI4hhFDoNWOSJEhkFaVAVo3tQNhMkFLu4R5f0pbp80LEiKqYtoVM5maTLMtUtY7jHFTK2ES0hZyhbpESjZaSLlmnkJucCW+4DTs43q44LtQJzdm1OVZZZ4UU6hv9DxzXgZAfcZ7nalaMf4V5LEoJT/1z+AYVoCcfRsUX/AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of files loaded in the import dialog",
            "title": "Example of files loaded in the import dialog",
            "src": "/static/0c117f1f61df7d9e73a743f53f1726e7/3cbba/09.png",
            "srcSet": ["/static/0c117f1f61df7d9e73a743f53f1726e7/7fc1e/09.png 288w", "/static/0c117f1f61df7d9e73a743f53f1726e7/a5df1/09.png 576w", "/static/0c117f1f61df7d9e73a743f53f1726e7/3cbba/09.png 1152w", "/static/0c117f1f61df7d9e73a743f53f1726e7/0b124/09.png 1728w", "/static/0c117f1f61df7d9e73a743f53f1726e7/4ea69/09.png 2304w", "/static/0c117f1f61df7d9e73a743f53f1726e7/0cbe4/09.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of files loaded in the import dialog</Caption>
      </Column>
    </Row>
    <h3>{`Import from a URL (full page or side-panel)`}</h3>
    <p>{`If your product supports importing from a URL, use this method.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.86280487804878%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABuklEQVQ4y62TyW7iQBRF+UaWTAIWbPkC5nkQiADdLLJCAmXVX5HsEhExRECEmOKG7kYCgxF4vO1XkROcgWxi6aqe7KpT99ZzWTRNw3c9xLJQoSgKJpMJRqMRhsMhBoPBWfX7fXS7XXQ6HbTbbfR6PRwOBwZlwPl8DqvVCr/fD6/XC4/HYxrfvvP5fKjVamg0GqjX62g2m1iv16/A8XgMp9OJTCaDVCqFXC6HbDb7Mho1KZ1Oo1yuYLfdfh6Z4tpsNiQSCYTDYYRCIQSDQUQiEVaTjDoQCLCNZ9wfbHZHSJKsE2TIsmx26HK5UCqV2GTDzakzo6bv5fIFnrgFeH6D3//2uHk4QlWV95GLxSKLRIs+EkHpSGjj1WqluxLBCyIeOdEMpMh2u50tiMViiMfjH4qOJBqNolAoYDabQRAESKLuTjqwP8UEdDgczMU5IImA+Xwe0+lUj8xju9uD3+7NQIpMTSEgLSDoZ6KmEVBV1ZP+6rWmQDOAtJvb7WYTKVYymTyrlH7OP6oVVH9eInq1RvyXir+bky6Losigy+USi8XiS3Ech/tWC7d3LVx3Bdz0JeyPz44t332X/wOWxU2HzcpMbQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of importing with a URL",
            "title": "Example of importing with a URL",
            "src": "/static/bc6f079a9d96175a8021ba2283e0d8fd/3cbba/10.png",
            "srcSet": ["/static/bc6f079a9d96175a8021ba2283e0d8fd/7fc1e/10.png 288w", "/static/bc6f079a9d96175a8021ba2283e0d8fd/a5df1/10.png 576w", "/static/bc6f079a9d96175a8021ba2283e0d8fd/3cbba/10.png 1152w", "/static/bc6f079a9d96175a8021ba2283e0d8fd/0b124/10.png 1728w", "/static/bc6f079a9d96175a8021ba2283e0d8fd/4ea69/10.png 2304w", "/static/bc6f079a9d96175a8021ba2283e0d8fd/0cbe4/10.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of importing with a URL</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.4451219512195%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABaElEQVQ4y62UzU+DQBTE+/8bE5MqUA82Hnsw3r148WiPNqVtTBQqhUCB/QAstOO+NUjbiFVTkslsdnm/fbOQ7Ww2GxzrIVaHBlVVYTabwrZtjMfjX4neJU0mNkajJ0RRpKEamGUZrvrXsHqXMAwTpmXBNE1YyttkGAbOu11cGD2cnJ7hcThsgNRh8V4hXwFlBazXaxw6ipdXB7c3AwzuA/QfAJ5VFLoBzucuXNeB7y/geZ5yH2EYai2XMZIkQRzHWjSmec97g+dHcBcJhJBNh2VZIk3Tr4K6iOY4S5FLBs4ZGOPKuXKmXUoJKZQLhlwd2w6QILQrgYQQWlIKRDHH8zxFkrIdGPmnOFLl2TaQIhMwCALttEgRVkWGqcPQv4uwCJnupgZui+0D68gUIc9zvUiSSkWeoVqpDfj3sFYgLdRR98W52IvZ6EdgW1FbZwcj/1f0IXeA9BMXRaHPj/yvojpqSgOPfTl8APaLJWc8hDqUAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of importing with a URL",
            "title": "Example of importing with a URL",
            "src": "/static/6eff556cb5bf53e5c3c97db41faa6093/3cbba/11.png",
            "srcSet": ["/static/6eff556cb5bf53e5c3c97db41faa6093/7fc1e/11.png 288w", "/static/6eff556cb5bf53e5c3c97db41faa6093/a5df1/11.png 576w", "/static/6eff556cb5bf53e5c3c97db41faa6093/3cbba/11.png 1152w", "/static/6eff556cb5bf53e5c3c97db41faa6093/0b124/11.png 1728w", "/static/6eff556cb5bf53e5c3c97db41faa6093/4ea69/11.png 2304w", "/static/6eff556cb5bf53e5c3c97db41faa6093/0cbe4/11.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of importing with a URL</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      